import { Component, Input, OnInit, ViewChild } from '@angular/core';

import { AlertController, ModalController, IonSlides } from '@ionic/angular';


import { AuthService } from "../../../service/auth/auth.service";
import {ModelPotatoseedOrder, order, seed, seedList} from "../../../models/potatoseed";

import { NgForm } from '@angular/forms';


import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';

//import {SortByTypePipe} from "../../pipes/sort-by-type";
import { ConfigService } from "../../../service/config/config.service";

import {LocaldataService} from "../../../service/localdata/localdata.service";



@Component({
  selector: 'page-potatoseedorder',
  templateUrl: 'potatoseedorder.html',
  styleUrls: ['potatoseedorder.scss'],
})
export class PotatoseedorderPage {
  @ViewChild('slides') slides: IonSlides;


  private form = {displayname:"", systemname:"", deadline:1, year:1, factoryId:1, id:1, status:"", onceperyear:false, tandc:"", formproperties:{potatoseedyear:""} };
  private factory = {displayname:"", address:{"street":""}};
  private appversion;
  private appplatform;
  private deviceinfo;


  private canBeClosed: boolean = false;

  //public order:ModelPotatoseedOrder;
  private tAndCs;
  private theOrder:ModelPotatoseedOrder


  private comment = '';
  private kurasdelivery:boolean = false;
  private pickup;
  



  public seedsLoaded: boolean = false;

  private seeds: Array<seedList> = [];

  public alertOpen: Boolean = false;


  public formSubmitting: boolean = false;


  public existingFormId: number = null;

  public storageId: number = null;



  private survey = {
    size_28_35: false,
    size_55_60: false,
    size_60_65: false,
    not_interested: false,
    dont_know: false,
    uses_band_layer: '',
    interested_early_delivery: ''
  };

  // Add validation method for survey
  async validateSurvey() {
    // Check if at least one size option is selected
    const sizeSelected = this.survey.size_28_35 || 
                        this.survey.size_55_60 || 
                        this.survey.size_60_65 || 
                        this.survey.not_interested || 
                        this.survey.dont_know;

    // Check if band layer question is answered
    const bandLayerAnswered = this.survey.uses_band_layer !== '';

    // Check if early delivery question is answered
    const earlyDeliveryAnswered = this.survey.interested_early_delivery !== '';

    if (!sizeSelected || !bandLayerAnswered || !earlyDeliveryAnswered) {
      const alert = await this.alertCtrl.create({
        header: 'Manglende information',
        message: 'Venligst besvar alle spørgsmål før du fortsætter.',
        buttons: ['OK']
      });
      await alert.present();
      return false;
    }

    return true;
  }

  onSizeOptionChange(option: string) {
    if (option === 'not_interested' && this.survey.not_interested) {
      // If "not interested" is checked, uncheck all other options
      this.survey.size_28_35 = false;
      this.survey.size_55_60 = false;
      this.survey.size_60_65 = false;
      this.survey.dont_know = false;
    } 
    else if (option === 'dont_know' && this.survey.dont_know) {
      // If "don't know" is checked, uncheck all other options
      this.survey.size_28_35 = false;
      this.survey.size_55_60 = false;
      this.survey.size_60_65 = false;
      this.survey.not_interested = false;
    }
    else if (option !== 'not_interested' && option !== 'dont_know') {
      // If any specific size is checked, only uncheck "not interested" and "don't know"
      if (this.survey[option]) { // Only uncheck if we're checking a box, not unchecking
        this.survey.not_interested = false;
        this.survey.dont_know = false;
      }
    }
  
    // Check if any specific sizes are selected
    const hasSpecificSizes = this.survey.size_28_35 || 
                            this.survey.size_55_60 || 
                            this.survey.size_60_65;
  
    // If no specific sizes are selected and neither "not interested" nor "don't know" is selected,
    // we don't need to do anything - allow the user to select multiple specific sizes
  }


  @Input() modalCtrl: ModalController;
  @Input() formobject: any;

  constructor(public alertCtrl: AlertController, private auth: AuthService, private httpClient: HttpClient, private config: ConfigService, public localData: LocaldataService) {

    //this.form = this.navParams.get('formobject');
    //this.factory = this.navParams.get('formobject').factory;

    this.appversion = this.config.version;
    this.appplatform = this.config.platformName;
    this.deviceinfo = this.config.deviceinfo;


    this.theOrder = new order().newOrder();



    //this.loadData();

    
    //let tAndCs = this.http.get(this.config.basePath + 'assets/potatoseeds.txt').subscribe((res:Response)=>{
    //let tAndCs = this.http.get('assets/potatoseeds.txt').subscribe((res:Response)=>{
      //console.log('tAndCs', this.form);
      //let tmpTandCs:string = this.form.tandc;
        //let tmpTandCs:string = (<any>res)._body;
        //tmpTandCs = tmpTandCs;//tmpTandCs.replace(/(\r\n|\n|\r)/gm, "<br/>")
        //this.tAndCs = tmpTandCs;
    //});

  }




  loadData(){
    this.getPreviousSubmittedDate().subscribe((resExistingData: any) => {
      var existingData: Array<any> = [];
      if(resExistingData != null && resExistingData.length>0 && resExistingData[0].data != null){
        existingData = resExistingData[0].data.additional.concat(resExistingData[0].data.ordinary);
        console.log('getPreviousSubmittedDate', existingData);
        this.comment = resExistingData[0].data.comment;
        //this.kurasdelivery = resExistingData[0].data.kurasdelivery;
        this.pickup = resExistingData[0].data.pickup;
        this.existingFormId = resExistingData[0].id;
        this.storageId = resExistingData[0].storageId;

        if (resExistingData[0].data.survey) {
          this.survey = {
            size_28_35: resExistingData[0].data.survey.size_28_35 || false,
            size_55_60: resExistingData[0].data.survey.size_55_60 || false,
            size_60_65: resExistingData[0].data.survey.size_60_65 || false,
            not_interested: resExistingData[0].data.survey.not_interested || false,
            dont_know: resExistingData[0].data.survey.dont_know || false,
            uses_band_layer: resExistingData[0].data.survey.uses_band_layer || '',
            interested_early_delivery: resExistingData[0].data.survey.interested_early_delivery || ''
          };
        }

      }
      
  
        this.getFormData().subscribe((res: any) => {
    
   
            var seedName: string;
            var newObj: any = {
              displayname: "",
              type: "",
              year: "",
              classes: []
            }
    
            for(var i:number = 0; i<res.length; i++) {
                var existingAmountLoose = existingData.find(x => (x.type == res[i].type && x.name == res[i].displayname.toLowerCase() && x.class == res[i].classname && x.unit == 'loose'));
                var existingAmountLarge = existingData.find(x => (x.type == res[i].type && x.name == res[i].displayname.toLowerCase() && x.class == res[i].classname && x.unit == 'large'));    
              if (res[i].displayname != seedName) {
    
                if(i>0){
                  this.seeds.push(newObj);
                }
    
                seedName = res[i].displayname
    
                newObj = {
                  displayname: res[i].displayname,
                  type: res[i].type,
                  year: res[i].year,
                  classes: []
                }
    

                
                //console.log('hasExistingValue', hasExistingValue);
    
                newObj.classes.push({
                  priceloose: res[i].priceloose,
                  pricelarge: res[i].pricelarge,
                  classname: res[i].classname,
                  amountloose: existingAmountLoose != undefined ? existingAmountLoose.amount : null,
                  amountlarge: existingAmountLarge != undefined ? existingAmountLarge.amount : null,
                  sku: res[i].sku
                });

                
    
              } else if(res[i].displayname === seedName) {
    
                newObj.classes.push({
                  priceloose: res[i].priceloose,
                  pricelarge: res[i].pricelarge,
                  classname: res[i].classname,
                  amountloose: existingAmountLoose != undefined ? existingAmountLoose.amount : null,
                  amountlarge: existingAmountLarge != undefined ? existingAmountLarge.amount : null,
                  sku: res[i].sku
                });
    
                
              }
              if(i === res.length-1){
                this.seeds.push(newObj);
              }
    
            }
            //(this.seeds);
            this.seedsLoaded = true;
    
            //this.seeds = res;
  
      })
      
    });

  }





getFormData(){
  let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Authorization', localStorage.getItem('access_token') || '{}');

    const options = {
      headers: headers
    };

  //console.log('THIS YEAR', this.form.formproperties.potatoseedyear);
  return this.httpClient.get(this.config.basePath + '/api/potatoseeds/' + '?filter={"where":{"year":"' + this.form.formproperties.potatoseedyear + '"}}', options)
}


  


  getPreviousSubmittedDate(){
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Authorization', localStorage.getItem('access_token') || '{}');

    const options = {
      headers: headers
    };

    return this.httpClient.get(this.config.basePath + '/api/farmers/' + this.auth.userProfile.id + '/forms?filter={"where":{"formavailableId":' + this.form.id + '}, "fields":{"datahistory":false}}', options)

  }




  changeValidationState(){
    //this.slides._slides[this.slides.getActiveIndex()].setAttribute("validated", "true");
  }

  async nextSlide(){
    const currentIndex = await this.slides.getActiveIndex();
    if (currentIndex === 6) { // Adjust this index based on your slide order
      const isValid = await this.validateSurvey();
      if (!isValid) {
        return;
      }
    }

    //console.log(this.slides.length(), this.slides.getActiveIndex(), this.slides._slides[this.slides.getActiveIndex()].getAttribute("validated"));
   // if(this.slides._slides[this.slides.getActiveIndex()].getAttribute("validated")=="true"){
      this.slides.slideNext();
   // }
  }

  async prevSlide(){
    //console.log(this.slides.length(), this.slides.getActiveIndex(), this.slides._slides[this.slides.getActiveIndex()].getAttribute("validated"));
    //if(this.slides._slides[this.slides.getActiveIndex()].getAttribute("validated")=="true"){
      this.slides.slidePrev();
   // }
  }


  submitForm(orderForm:NgForm){

    this.formSubmitting = true;

    var submitformdata =
      {
        "systemname": this.form.systemname,
        "displayname": this.form.displayname,
        "completed": true,
        "deadline": this.form.deadline,
        "year": this.form.year,
        "data": this.theOrder,
        "factoryId": this.form.factoryId,
        "farmerId": this.auth.userProfile.id,
        "formavailableId": this.form.id,
        "storageId": this.storageId,
        "formProperties": this.form.formproperties
      }

     



    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Authorization', localStorage.getItem('access_token') || '{}');

    const options = {
      headers: headers
    };
    console.log('SUBMIT', this.existingFormId);
    if(this.existingFormId == null){

      //submitformdata["datahistory"] = [];

      this.httpClient.post(this.config.basePath + '/api/forms', submitformdata, options)
        .subscribe(
          (res: Response) => {
            this.formSubmitting = false;

            //if (res) {
              //if (res.status === 200) {
                //if(this.form.onceperyear){
                  //this.form.status = 'completed';
                //}

                this.localData.remoteUpdateFormsAvailable().then(() =>{
                  this.nextSlide();
                });

              //}
            //}
          },
          (err) => {


            let alert = this.alertCtrl.create({
              header: 'Der opstod en fejl ved bestilling',
              message: 'Prøv igen. Hvis problemet fortsætter kontakt da venligst ' + this.factory.displayname,
              buttons: ['OK']
            });
            //alert.present();

          }
        );
    }else{

      //submitformdata["datahistory"] = [];

      this.httpClient.patch(this.config.basePath + '/api/forms/' + this.existingFormId, submitformdata, options)
      .subscribe(
        (res: Response) => {
          this.formSubmitting = false;

          //if (res) {
            //if (res.status === 200) {
              //if(this.form.onceperyear){
                //this.form.status = 'completed';
              //}

              this.localData.remoteUpdateFormsAvailable().then(() =>{
                this.nextSlide();
              });

            //}
          //}
        },
        (err) => {
          let alert = this.alertCtrl.create({
            header: 'Der opstod en fejl ved bestilling',
            message: 'Prøv igen. Hvis problemet fortsætter kontakt da venligst ' + this.factory.displayname,
            buttons: ['OK']
          });
          //alert.present();

        }
      );
    }


  }


  getSeeds(type: string):Array<any> {


      //return this.seeds.filter((listing: any) => listing.type === type);
    //var tmpSeedlist = this.seeds.filter((listing: any) => listing.type === type);
    //console.log(tmpSeedlist);


    return this.seeds.filter((listing: any) => listing.type === type);

  }


  createOrder(orderForm:NgForm){
    const value = orderForm.value;

    this.theOrder.ordinary = [];
    this.theOrder.additional = [];


    this.theOrder.sender = this.auth.userProfile;
    //theOrder.meta.sendername = value.sendername;
    //theOrder.meta.receiver = value.receiver;
    //theOrder.meta.receivername = value.receivername;


    this.theOrder.comment = this.comment;
    //this.theOrder.kurasdelivery = this.kurasdelivery;
    this.theOrder.pickup = this.pickup;

    this.theOrder.survey = this.survey;


    for (let obj in orderForm.controls) {
      //console.log(obj);

      if( value[obj] != null  &&  value[obj]!="" ){
        if(obj.startsWith("ordinary")){
          let objStringArr = obj.split("_"); //0:ordinary 1:s 2:kuras 3:large
          //console.log('obj', obj);

          let newOrderLine;
          for (let seed of this.seeds) {
            if(seed.displayname.toLowerCase() == objStringArr[2].toString()) {
              for (let theClass of seed.classes) {
                if (theClass.classname === objStringArr[1].toString()) {
                  newOrderLine = {
                    name: objStringArr[2].toString(),
                    class: objStringArr[1].toString(),
                    type: objStringArr[0].toString(),
                    unit: objStringArr[3].toString(),
                    price: (objStringArr[3].toString() == 'loose' ? theClass.priceloose : theClass.pricelarge),
                    amount: value[obj],
                    sku: objStringArr[4].toString()
                  };
                }
              }
            }
          }

          this.theOrder.ordinary.push(newOrderLine);
        }

        if(obj.startsWith("additional")){
          let objStringArr = obj.split("_"); //0:ordinary 1:s 2:kuras 3:large

          let newOrderLine;
          for (let seed of this.seeds) {
            if(seed.displayname.toLowerCase() == objStringArr[2].toString()) {
              for (let theClass of seed.classes) {
                if (theClass.classname === objStringArr[1].toString()) {
                  newOrderLine = {
                    name: objStringArr[2].toString(),
                    class: objStringArr[1].toString(),
                    type: objStringArr[0].toString(),
                    unit: objStringArr[3].toString(),
                    price: null,
                    amount: value[obj],
                    sku: objStringArr[4].toString()
                  };
                }
              }
            }
          }

          //let newOrderLine = {name: objStringArr[1].toString() + '_' + objStringArr[2].toString() + '_' + objStringArr[3].toString(), value: value[obj]};
          this.theOrder.additional.push(newOrderLine);
        }
      }
    }
    //console.log(this.theOrder);
    this.nextSlide();
  }

  onAddOrder(orderForm:NgForm){

  }


  async checkValueLarge(objTarget){
    var calcValue = Number(objTarget.value.toString().replace(',', '.'));

    if(calcValue % 12.5 != 0 && !this.alertOpen){


      let alert = await this.alertCtrl.create({
        header: 'Bemærk',
        message: 'Mængden skal være delelig med 12,5',
        buttons: [
          {
            text: 'OK',
            handler: () => {
              setTimeout( () => { objTarget.focus(); this.alertOpen = false;}, 500 );
            }
          }
        ]
      });
      await alert.present();
      return;
    }
  }
  async checkValueLoose(objTarget){
    if(objTarget.value && objTarget.value < 150 && !this.alertOpen){


      let alert = await this.alertCtrl.create({
        header: 'Bemærk',
        message: 'Mængden skal minimum være 150hkg',
        buttons: [
          {
            text: 'OK',
            handler: () => {
              setTimeout( () => { objTarget.focus(); this.alertOpen = false;}, 500 );
            }
          }
        ]
      });
      await alert.present();
      return;
    }
  }


  completeOrder(){
    this.canBeClosed = true;
    //this.navCtrl.pop();
    this.modalCtrl.dismiss();
  }

  closeModal() {
    //this.navCtrl.pop();
    this.modalCtrl.dismiss();
  }


  ngOnInit() {
    this.form = this.formobject;
      console.log('log', this.formobject)
      this.factory = this.formobject.factory;
      //this.year = this.formobject.year;

      this.loadData();
      
      //console.log('tAndCs', this.form.tandc);
      let tmpTandCs:string = this.form.tandc;
        //let tmpTandCs:string = (<any>res)._body;
        tmpTandCs = tmpTandCs;//tmpTandCs.replace(/(\r\n|\n|\r)/gm, "<br/>")
        this.tAndCs = tmpTandCs;
      
      //.then(data => {
        //console.log('DATA', data)
        //this.stamdataIsLoaded = true;
     // })

    /*this.getStamdata().then(data => {
      //console.log('DATA', data)
      this.stamdataIsLoaded = true;
    })*/



  }


  ionViewDidLoad() {
    console.log('ionViewDidLoad FormsPotatoseedPage');
    //this.slides.centeredSlides = false;
  }

  ionViewCanLeave(): Promise<{}> {
    if(this.canBeClosed){
      return new Promise((resolve, reject) => {
        //resolve();
      });
    }else {
      return new Promise((resolve, reject) => {
        let confirm = this.alertCtrl.create({
          header: 'Er du sikker på at du vil afbryde bestillingen?',
          message: 'Du mister derved alle indtastninger',
          buttons: [{
            text: 'OK',
            handler: () => {
              //resolve();
            },
          }, {
            text: 'Cancel',
            handler: () => {
              reject();
            }
          }],
          //enableBackdropDismiss: false
        });
        //confirm.present();
      })
    }
  }

}
